<template>
  <v-row class="fill-height pa-0 ma-0">
    <v-col lg="6" v-if="$vuetify.breakpoint.lgAndUp"
           class="fill-height d-flex justify-center align-center primary elevation-5">
      <v-fade-transition mode="out-in">
        <v-img @click="$routerService.goTo('main')"
               class="hover"
               src="@/assets/logo_circle.png"
               max-width="200"></v-img>
      </v-fade-transition>
    </v-col>
    <v-col cols="12" lg="6" class="fill-height pa-1 pa-lg-10">
      <validation-observer v-slot="{ passes }">
        <v-form @submit.prevent="passes(submit)">
          <v-card tile flat>
            <v-card-title>{{ $t('developers.contact') }}</v-card-title>
            <v-card-text>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-row class="ma-0 ">
                    <v-col cols="4" class="pl-0">
                      <validation-provider rules="required"
                                           :name="$t('developers.form.name')" v-slot="{ errors }">
                        <v-text-field dense v-model="form.name"
                                      :label="$t('developers.form.labelName')"
                                      :placeholder="$t('developers.form.name')"
                                      :error-messages="errors"
                                      type="text"></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4" class="pl-0">
                      <validation-provider rules="required"
                                           :name="$t('developers.form.surname')" v-slot="{ errors }">
                        <v-text-field dense v-model="form.surname"
                                      :label="$t('developers.form.labelSurname')"
                                      :placeholder="$t('developers.form.surname')"
                                      :error-messages="errors"
                                      type="text"></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4" class="pr-0">
                      <validation-provider rules="required" :name="$t('developers.form.email')" v-slot="{ errors }">
                        <v-text-field dense v-model="form.email"
                                      :label="$t('developers.form.labelEmail')"
                                      :placeholder="$t('developers.form.email')"
                                      :error-messages="errors"
                                      type="email"></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" class="pl-0 pr-0">
                      <validation-provider rules="required" :name="$t('developers.form.message')" v-slot="{ errors }">
                        <v-textarea dense v-model="form.message"
                                    :label="$t('developers.form.labelMessage')"
                                    :placeholder="$t('developers.form.message')"
                                    :error-messages="errors"
                        ></v-textarea>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn type="button"
                     v-if="$vuetify.breakpoint.mobile"
                     @click="$routerService.goTo('main')"
                     min-width="30%"
                     color="primary" tile>
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                     type="submit"
                     min-width="30%"
                     :loading="loading"
                     color="primary" tile>{{ $t('developers.submit') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </validation-observer>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      form: {
        name: null,
        surname: null,
        message: null,
        email: null
      },
      loading: false
    }
  },
  methods: {
    submit() {
      this.loading = true;
      this.$http.post('api/v2/send-message', this.form)
          .then(() => {
            this.$routerService.goTo('main')
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>

</style>
